import React from "react";
import { CardPartnerAlt } from "../global/CardPartnerAlt";
import takaiImg from "../../images/hackathon/takai.svg";
import easyImg from "../../images/hackathon/easy.svg";
import devdaoImg from "../../images/hackathon/developer-dao.svg";
import ethImg from "../../images/hackathon/eth-global.svg";
import bboxImg from "../../images/hackathon/buildbox.svg";
import btcImg from "../../images/hackathon/btc.svg";
import encodeImg from "../../images/hackathon/encode.svg";
import doraImg from "../../images/hackathon/dorahacks.svg";
import thirdwebImg from "../../images/hackathon/thirdweb.svg";
import gelatoImg from "../../images/hackathon/gelato.png";

const partners = [
  { id: "eth-global", title: "ETH Global", image: ethImg, link: "https://ethglobal.com/" },
  { id: "easya", title: "EasyA", image: easyImg, link: "https://www.easya.io/" },
  { id: "encode", title: "Encode", image: encodeImg, link: "https://www.encode.club/" },
  { id: "taikai", title: "Taikai", image: takaiImg, link: "https://taikai.network/es" },
  { id: "developer-dao", title: "Developer DAO", image: devdaoImg, link: "https://www.developerdao.com/" },
  { id: "dorahacks", title: "DoraHacks", image: doraImg, link: "https://dorahacks.io/" },
  { id: "buildbox", title: "BuildBox", image: bboxImg, link: "https://signup.buildbox.com/" },
  { id: "btc-inc", title: "BTC Inc", image: btcImg, link: "https://b.tc/conference/2024/bitcoin-games" },
  { id: "thirdweb", title: "Thirdweb", image: thirdwebImg, link: "https://thirdweb.com/" },
  { id: "gelato", title: "Gelato", image: gelatoImg, link: "https://www.gelato.network/" },
];

export const Community = () => {
  return (
    <section className="community-partners-section container">
      <div className="header mb-5 pb-5">
        <span className="zg-label bg-cyan mb-5">Collaborate</span>
        <h2 className="h3 mt-5 mb-3">Community partners</h2>
      </div>
      <div className="container">
        <div className="partners-grid">
          {partners.map((partner) => (
            <CardPartnerAlt key={partner.id} {...partner} />
          ))}
        </div>
      </div>
    </section>
  );
};

